// labels
import { NEVER, REGULAR } from 'constants/managementUI'

export const LABEL_IS_COMPLETED = 'isCompleted'
export const LABEL_IS_IN_PROGRESS = 'isInProgress'
export const LABEL_START = 'start'
export const LABEL_STOP = 'stop'
export const LABEL_NO_DELAY = 'noDelay'
export const LABEL_NEXT_DAY = 'nextDay'
export const LABEL_AFTER_ONE_WEEK = 'afterOneWeek'
export const LABEL_CUSTOM = 'custom'
export const LABEL_WHEN_COMPLETED = 'whenCompleted'
export const LABEL_DAYS = 'day_s'
export const LABEL_WEEKS = 'week_s'
export const LABEL_MONTHS = 'month_s'
export const LABEL_OCCURRENCES = 'occurrence_s'
export const LABEL_NEVER = 'never'

// values
export const VALUE_IS_COMPLETED = 'completed'
export const VALUE_IS_IN_PROGRESS = 'in_progress'
export const VALUE_START = 'start'
export const VALUE_STOP = 'stop'
export const VALUE_NO_DELAY = 'no_delay'
export const VALUE_NEXT_DAY = 'next_day'
export const VALUE_AFTER_ONE_WEEK = 'after_one_week'
export const VALUE_CUSTOM = 'custom'
export const VALUE_WHEN_PARENT_COMPLETED = 'parent_completed'
export const VALUE_WHEN_PARENT_INPUT = 'parent_input'
export const VALUE_DAYS = 'days'
export const VALUE_WEEKS = 'weeks'
export const VALUE_MONTHS = 'months'
export const VALUE_OCCURRENCES = 'occurrences'
export const VALUE_NEVER = 'never'
export const VALUE_REGULAR = 'regular'
export const VALUE_AFTER = 'after'

// Fields/columns
export const FIELD_TRIGGER_JOB_WORKFLOW = 'triggerJobWorkflow'
export const FIELD_TRIGGERED_JOB_WORKFLOW = 'triggeredJobWorkflow'
export const FIELD_NAME = 'name'
export const FIELD_TRIGGER_TYPE = 'triggerType'
export const FIELD_TRIGGER_ACTION = 'triggerAction'
export const FIELD_TRIGGER_INPUTS = 'triggerInputs'
export const FIELD_SITE = 'site'
export const FIELD_SITES = 'sites'
export const FIELD_ASSIGNMENT = 'assignment'
export const FIELD_ACTIVE = 'active'
export const FIELD_START_DATE = 'startDate'
export const FIELD_START_DATE_INPUT = 'startDateInput'
export const FIELD_START_DELAY = 'startDelay'
export const FIELD_START_DELAY_DAYS = 'startDelayDays'
export const FIELD_START_DELAY_SECONDS = 'startDelaySeconds'
export const FIELD_REPEAT = 'repeat'
export const FIELD_DUE_DATE = 'dueDate'
export const FIELD_DUE_DATE_DAYS = 'dueDateDays'
export const FIELD_DUE_DATE_TIME = 'dueDateTime'
export const FIELD_TRIGGER_INPUT_VALUES = 'triggerJobWorkflowInputValues'
export const FIELD_TRIGGER_JOB_WORKFLOW_TASK = 'triggerJobWorkflowTask'
export const REGULAR_REPEAT_SCHEDULE = 'regularRepeatSchedule'
export const END_DATE = 'endDate'
export const END_DATE_AFTER_NUMBER = 'endDateAfterNumber'
export const END_DATE_AFTER_TERM = 'endDateAfterTerm'
export const REPEAT_BY = 'repeatBy'
export const FREQUENCY = 'frequency'
export const WEEK_ORDINARY_NUMBER = 'weekOrdinalNumber'
export const DAY_OF_WEEK = 'dayOfWeek'
export const DAYS_OF_WEEK = 'daysOfWeek'
export const DAY_OF_MONTH = 'dayOfMonth'
export const REPEAT = 'repeat'
export const START_TIME = 'startTime'
export const TRIGGER_ASSIGNMENTS = 'triggerAssignments'

// triggers actions
export const TRIGGER_ACTIONS = [
  {
    label: LABEL_IS_COMPLETED,
    value: VALUE_IS_COMPLETED,
  },
  {
    label: LABEL_IS_IN_PROGRESS,
    value: VALUE_IS_IN_PROGRESS,
  },
]
export const TRIGGERED_ACTIONS = [
  {
    label: LABEL_START,
    value: VALUE_START,
  },
  {
    label: LABEL_STOP,
    value: VALUE_STOP,
  },
]
export const ADDITIONAL_DELAY_ACTIONS = [
  {
    label: LABEL_NO_DELAY,
    value: VALUE_NO_DELAY,
  },
  {
    label: LABEL_NEXT_DAY,
    value: VALUE_NEXT_DAY,
  },
  {
    label: LABEL_AFTER_ONE_WEEK,
    value: VALUE_AFTER_ONE_WEEK,
  },
  {
    label: LABEL_CUSTOM,
    value: VALUE_CUSTOM,
  },
]
export const ADDITIONAL_END_DELAY_ACTIONS = [
  {
    label: LABEL_NEVER,
    value: VALUE_NEVER,
  },
  {
    label: LABEL_CUSTOM,
    value: VALUE_CUSTOM,
  },
]

export const DEFAULT_TRIGGER_START_OPTION = {
  label: LABEL_WHEN_COMPLETED,
  value: VALUE_WHEN_PARENT_COMPLETED,
}

export const DAYS_OF_MONTH = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
  { label: '21', value: 21 },
  { label: '22', value: 22 },
  { label: '23', value: 23 },
  { label: '24', value: 24 },
  { label: '25', value: 25 },
  { label: '26', value: 26 },
  { label: '27', value: 27 },
  { label: '28', value: 28 },
  { label: '29', value: 29 },
  { label: '30', value: 30 },
  { label: '31', value: 31 },
]

export const WEEK_NUMBERS = [
  { label: 'first', value: 'first' },
  { label: 'second', value: 'second' },
  { label: 'third', value: 'third' },
  { label: 'fourth', value: 'fourth' },
  { label: 'fifth', value: 'fifth' },
  { label: 'last', value: 'last' },
]

export const DAYS_OF_WEEK_OPTIONS = [
  { label: 'monday', value: 'Mon' },
  { label: 'tuesday', value: 'Tue' },
  { label: 'wednesday', value: 'Wed' },
  { label: 'thursday', value: 'Thu' },
  { label: 'friday', value: 'Fri' },
  { label: 'saturday', value: 'Sat' },
  { label: 'sunday', value: 'Sun' },
]

export const DAYS_OF_WEEK_SHORTENED_OPTIONS = [
  { label: 'mon', value: 'Mon' },
  { label: 'tue', value: 'Tue' },
  { label: 'wed', value: 'Wed' },
  { label: 'thu', value: 'Thu' },
  { label: 'fri', value: 'Fri' },
  { label: 'sat', value: 'Sat' },
  { label: 'sun', value: 'Sun' },
]

export const END_DATE_TERMS = [
  { label: 'days', value: 'days' },
  { label: 'months', value: 'months' },
  { label: 'weeks', value: 'weeks' },
  { label: 'occurrences', value: 'occurrences' },
]

export const FORMATTED_REPEAT_ACTIONS = [
  {
    label: 'never',
    value: NEVER,
  },
  {
    label: 'regular',
    value: REGULAR,
  },
]

export const FORMATTED_STOP_RECURRENCE_ACTIONS = [
  {
    label: 'days',
    value: VALUE_DAYS,
  },
  {
    label: 'weeks',
    value: VALUE_WEEKS,
  },
  {
    label: 'months',
    value: VALUE_MONTHS,
  },
]
